export default "__VITE_ASSET__d99bc933__"